import { render, staticRenderFns } from "./SupportBtn.vue?vue&type=template&id=16038fe8&scoped=true&"
import script from "./SupportBtn.vue?vue&type=script&lang=js&"
export * from "./SupportBtn.vue?vue&type=script&lang=js&"
import style0 from "./SupportBtn.vue?vue&type=style&index=0&id=16038fe8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16038fe8",
  null
  
)

export default component.exports